module.exports = __webpack_public_path__ + "static/media/assembly.9c5a4ee0.svg";